import { defineComponent as _defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Appointments',
  setup(__props) {



return { __sfc: true,Header, Footer }
}

})